import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import SharedForm from '../../../../components/ui/Form';
import {
    EAC_PHONE_TYPE,
    POSITIONS,
    VALIDATIONS,
    YES_NO_INVERSE,
} from '../../../../constants';
import { radioOptionValues } from '../../../../utils/utils';
import '../../../../../src/App.scss';

const CareGiverRepeater = ({ eventKey, onInputChange, onFormValidate, title = "Add Caregiver", fieldPrefix = null, modelObj = null }) => {

    const [careGiverFields, setCareGiverFields] = useState([]);
    const [careGiver, setCareGiver] = useState(null);

    let careGiverArr = [
        {
            key: 'careGiver_firstName',
            labelName: 'First Name',
            placeholderName: 'First Name',
            type: 'text',
            valid: VALIDATIONS.String.isName,
            maxLength: 35,
        },
        {
            key: 'careGiver_lastName',
            labelName: 'Last Name',
            placeholderName: 'Last Name',
            type: 'text',
            valid: VALIDATIONS.String.isName,
            maxLength: 35,
        },
        {
            key: 'careGiver_phone',
            labelName: 'Phone Number',
            placeholderName: 'Phone Number',
            type: 'tel',
            maxLength: 12,
            required: false,
            valid: VALIDATIONS.Number.isPhone,
        },
        {
            key: 'careGiver_phoneType',
            labelName: '',
            type: 'radio',
            required: false,
            optionValues: radioOptionValues(EAC_PHONE_TYPE),
        },
        {
            key: 'careGiver_email',
            labelName: 'Email',
            placeholderName: 'Email',
            type: 'email',
            required: false,
            maxLength: 255,
        },
        {
            key: 'careGiver_hipaaFormFlag',
            labelName: 'HIPAA Form Complete',
            type: 'radio',
            required: false,
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
            maxLength: 12,
        },
        {
            key: 'careGiver_memberFlag',
            labelName: 'Company Plan Member',
            type: 'radio',
            required: false,
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
            maxLength: 12,
        },
        {
            key: 'careGiver_guardianFlag',
            labelName: 'Guardian Flag',
            type: 'radio',
            required: false,
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
        },
        {
            key: 'careGiver_docCode',
            labelName: 'Doc Code',
            placeholderName: 'Doc Code',
            type: 'text',
            required: false,
            maxLength: 4,
        },
        {
            key: 'careGiver_comment',
            labelName: 'Comments',
            placeholderName: 'Comments',
            type: 'textarea',
            required: false,
            maxLength: 255,
            charCounter: true,
            valid: VALIDATIONS.String.noSpecialChars,
        },
    ];

    useEffect(() => {
        if (fieldPrefix) {
            const prefixedCareGiverArr = careGiverArr.map(field => ({
                ...field,
                key: `${fieldPrefix}_${field.key}`,
            }));
            setCareGiverFields(prefixedCareGiverArr);
        } else {
            setCareGiverFields(careGiverArr);
        }
    }, []);

    useEffect(() => {
        if (modelObj) {
            setCareGiver(modelObj);
        }
    }, [modelObj]);

    return (
        <Accordion.Item eventKey={eventKey}>
            <Accordion.Header>{title}</Accordion.Header>
            <Accordion.Body>
                <SharedForm
                    cols={12}
                    array={careGiverFields}
                    modelObj={modelObj ?? careGiver}
                    onInputChanged={onInputChange}
                    onFormValidate={onFormValidate}
                    actionBarPosition={POSITIONS.NONE}
                />
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default CareGiverRepeater;
